import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import type { DeviceType } from '@devices';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeviceTypeService {
  private http = inject(HttpClient);

  getDeviceTypes(): Observable<DeviceType[]> {
    return this.http
      .get<{ data: DeviceType[]; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-types`)
      .pipe(map(response => response.data));
  }

  deleteDeviceType(deviceTypeId: string) {
    return this.http.delete(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-types/${deviceTypeId}`);
  }

  updateDeviceTypeName(deviceTypeId: string, name: string) {
    return this.http
      .patch<{ data: DeviceType; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-types/${deviceTypeId}`, { name })
      .pipe(map(response => response.data));
  }

  addNewDeviceType(data: Pick<DeviceType, 'name'>): Observable<DeviceType> {
    return this.http
      .post<{ data: DeviceType; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-types`, data)
      .pipe(map(response => response.data));
  }
}
